import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = {
  key: 2
};
var _hoisted_3 = {
  key: 3
};
var _hoisted_4 = {
  key: 5
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  key: 2,
  "class": /*@__PURE__*/_normalizeClass(['image-container-hover'])
};
var _hoisted_7 = {
  "class": /*@__PURE__*/_normalizeClass(['image-container-hover-text'])
};
import TUIChatEngine, { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, watchEffect } from "../../../../adapter-vue";
import { isPC } from "../../../../utils/env";
import { generateSearchResultShowName, generateSearchResultAvatar, generateSearchResultShowContent, generateSearchResultTime, enterConversation } from "../../utils";
import { messageTypeAbstractMap, searchResultItemDisplayType, searchMessageType } from "../../type";
import MessageAbstractText from "./message-abstract/message-abstract-text.vue";
import MessageAbstractFile from "./message-abstract/message-abstract-file.vue";
import MessageAbstractCustom from "./message-abstract/message-abstract-custom.vue";
import MessageAbstractImage from "./message-abstract/message-abstract-image.vue";
import MessageAbstractVideo from "./message-abstract/message-abstract-video.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    listItem: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    listItemContent: {
      required: false,
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    type: {
      type: String,
      "default": "allMessage",
      validator: function validator(value) {
        return Object.values(searchMessageType).includes(value);
      }
    },
    displayType: {
      type: String,
      "default": "info",
      validator: function validator(value) {
        return Object.values(searchResultItemDisplayType).includes(value);
      },
      required: true
    },
    keywordList: {
      // 搜索匹配关键词，用来处理高亮展示
      type: Array,
      "default": []
    }
  },
  emits: ["showResultDetail", "navigateToChatPosition"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var TYPES = ref(TUIChatEngine.TYPES);
    var avatarForShow = ref();
    var nameForShow = ref();
    var contentForShow = ref();
    var timeForShow = ref();
    var isHovering = ref();
    watchEffect(function () {
      var _props$listItem, _props$listItem2;
      avatarForShow.value = generateSearchResultAvatar(props.listItem, props === null || props === void 0 ? void 0 : props.listItemContent);
      nameForShow.value = generateSearchResultShowName(props.listItem, props === null || props === void 0 ? void 0 : props.listItemContent);
      contentForShow.value = generateSearchResultShowContent(props.listItem, props.type, props.keywordList, (props === null || props === void 0 ? void 0 : props.displayType) !== "bubble");
      timeForShow.value = props !== null && props !== void 0 && (_props$listItem = props.listItem) !== null && _props$listItem !== void 0 && _props$listItem.time ? generateSearchResultTime((props === null || props === void 0 || (_props$listItem2 = props.listItem) === null || _props$listItem2 === void 0 ? void 0 : _props$listItem2.time) * 1000) : "";
    });
    var onResultItemClicked = function onResultItemClicked() {
      if (props.type === "contact" || props.type === "group") {
        enterConversation(props.listItem);
      } else {
        var _props$listItem3;
        if (props.displayType === "info" && !(props !== null && props !== void 0 && (_props$listItem3 = props.listItem) !== null && _props$listItem3 !== void 0 && _props$listItem3.ID)) {
          emits("showResultDetail", true, props.type, props.listItem);
        } else {
          navigateToChatPosition();
        }
      }
    };
    var setHoverStatus = function setHoverStatus(status) {
      isHovering.value = status;
    };
    var navigateToChatPosition = function navigateToChatPosition() {
      // 定位到指定位置
      emits("navigateToChatPosition", props.listItem);
    };
    var getMessageAbstractType = function getMessageAbstractType(message) {
      return message !== null && message !== void 0 && message.type ? TUITranslateService.t("TUISearch.".concat(messageTypeAbstractMap[message.type])) : "";
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['search-result-list-item', !_unref(isPC) && 'search-result-list-item-h5', 'search-result-list-item-' + __props.displayType, _unref(isHovering) && 'hover-' + __props.displayType]),
        onClick: onResultItemClicked,
        onMouseenter: _cache[0] || (_cache[0] = function ($event) {
          return setHoverStatus(true);
        }),
        onMouseleave: _cache[1] || (_cache[1] = function ($event) {
          return setHoverStatus(false);
        })
      }, [__props.displayType === 'info' || __props.displayType === 'bubble' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass([__props.displayType])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(__props.displayType + '-left')
      }, [_createElementVNode("img", {
        "class": _normalizeClass(__props.displayType + '-left-avatar'),
        src: _unref(avatarForShow),
        onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
      }, null, 10, _hoisted_1)], 2), _createElementVNode("div", {
        "class": _normalizeClass([__props.displayType + '-main'])
      }, [_createElementVNode("div", {
        "class": _normalizeClass([__props.displayType + '-main-name'])
      }, _toDisplayString(_unref(nameForShow)), 3), _createElementVNode("div", {
        "class": _normalizeClass([__props.displayType + '-main-content'])
      }, [__props.displayType === 'info' || __props.listItem.type === _unref(TYPES).MSG_TEXT ? (_openBlock(), _createBlock(MessageAbstractText, {
        key: 0,
        content: _unref(contentForShow),
        highlightType: __props.displayType === 'info' ? 'font' : 'background',
        displayType: __props.displayType
      }, null, 8, ["content", "highlightType", "displayType"])) : __props.listItem.type === _unref(TYPES).MSG_FILE ? (_openBlock(), _createBlock(MessageAbstractFile, {
        key: 1,
        contentText: _unref(contentForShow),
        messageContent: __props.listItemContent
      }, null, 8, ["contentText", "messageContent"])) : __props.listItem.type === _unref(TYPES).MSG_IMAGE ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : __props.listItem.type === _unref(TYPES).MSG_VIDEO ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : __props.listItem.type === _unref(TYPES).MSG_CUSTOM ? (_openBlock(), _createBlock(MessageAbstractCustom, {
        key: 4,
        contentText: _unref(contentForShow),
        message: __props.listItem,
        messageContent: __props.listItemContent
      }, null, 8, ["contentText", "message", "messageContent"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(getMessageAbstractType(__props.listItem)), 1))], 2)], 2), _createElementVNode("div", {
        "class": _normalizeClass(__props.displayType + '-right')
      }, [_createElementVNode("div", {
        "class": _normalizeClass(__props.displayType + '-right-time')
      }, _toDisplayString(_unref(timeForShow)), 3), __props.displayType === 'bubble' && _unref(isHovering) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(__props.displayType + '-right-to'),
        onClick: navigateToChatPosition
      }, _toDisplayString(_unref(TUITranslateService).t("TUISearch.定位到聊天位置")), 3)) : _createCommentVNode("", true)], 2)], 2)) : __props.displayType === 'file' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass([__props.displayType])
      }, [_createElementVNode("div", {
        "class": _normalizeClass([__props.displayType + '-header'])
      }, [_createElementVNode("img", {
        "class": _normalizeClass(__props.displayType + '-header-avatar'),
        src: _unref(avatarForShow),
        onerror: "this.onerror=null;this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
      }, null, 10, _hoisted_5), _createElementVNode("div", {
        "class": _normalizeClass([__props.displayType + '-header-name'])
      }, _toDisplayString(_unref(nameForShow)), 3), _unref(isHovering) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(__props.displayType + '-header-to'),
        onClick: navigateToChatPosition
      }, _toDisplayString(_unref(TUITranslateService).t("TUISearch.定位到聊天位置")), 3)) : _createCommentVNode("", true), _createElementVNode("div", {
        "class": _normalizeClass(__props.displayType + '-header-time')
      }, _toDisplayString(_unref(timeForShow)), 3)], 2), _createElementVNode("div", {
        "class": _normalizeClass([__props.displayType + '-main-content'])
      }, [_createVNode(MessageAbstractFile, {
        contentText: _unref(contentForShow),
        messageContent: __props.listItemContent
      }, null, 8, ["contentText", "messageContent"])], 2)], 2)) : __props.displayType === 'image' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        "class": _normalizeClass([__props.displayType])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['image-container']),
        onClick: navigateToChatPosition
      }, [__props.listItem.type === _unref(TYPES).MSG_IMAGE ? (_openBlock(), _createBlock(MessageAbstractImage, {
        key: 0,
        messageContent: __props.listItemContent
      }, null, 8, ["messageContent"])) : __props.listItem.type === _unref(TYPES).MSG_VIDEO ? (_openBlock(), _createBlock(MessageAbstractVideo, {
        key: 1,
        messageContent: __props.listItemContent
      }, null, 8, ["messageContent"])) : _createCommentVNode("", true), _unref(isHovering) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(TUITranslateService).t("TUISearch.定位到聊天位置")), 1)])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true)], 34);
    };
  }
});